import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/icash-transactions")({
  staticData: { breadcrumb: { label: "sidebar.expenses" } },
  component: () => <Outlet />,
});
